import axios from "axios";
export default {
  movements: (id, params = { page: 1, per_page: 10 }, cancelToken) =>
    axios.get(`/api/stocks/${id}/movements`, { params, cancelToken }),
  movementsReport: (id, cancelToken) =>
    axios.get(`/api/stocks/${id}/movement-report`, { cancelToken, responseType: "blob" })
};
